var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeBetAmount as changeBetAmountAction } from '../../../actions/coupon/creators/coupon';
import { resourceNames, getResourceAmount } from '../../../constants/accountResourceNames';
import { cssClassMap } from '../../../constants/SportCssMap';
import { isRateUnavailable } from '../rateUtils';
import StakeVariants from '../StakeVariants';
import _Input from './_Input';
import RenderBetItem from './RenderBetItem';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import * as BetStatus from '../../../constants/BetStatus';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
var messages = defineMessages({
    bets_potential_return: {
        id: 'bets.potential_return',
        defaultMessage: 'Возможный выигрыш:'
    },
    total_bet_amount: {
        id: 'coupon.total_amount2',
        defaultMessage: 'Общая сумма ставки',
    },
    coupon_stake_amount: {
        id: 'coupon.stake_amount',
        defaultMessage: 'Сумма ставки'
    },
});
var Single = /** @class */ (function (_super) {
    __extends(Single, _super);
    function Single() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElement = null;
        _this.deleteBetSlip = function (id) {
            _this.props.deleteBetSlipAction(id);
        };
        _this.changeAmount = function (e) {
            if (!_this.props.freebetToggled) {
                _this.props.changeBetAmountAction(e.target.value.replace(/\D/g, ''));
            }
        };
        _this.addBtnHandler = function (couponAmountValue, amount) {
            _this.props.changeBetAmountAction(+couponAmountValue + amount);
        };
        _this.subtractBtnHandler = function (couponAmountValue, amount) {
            if (+couponAmountValue >= amount) {
                _this.props.changeBetAmountAction(+couponAmountValue - amount);
            }
        };
        return _this;
    }
    Single.prototype.componentDidMount = function () {
        this.targetElement = document.querySelector('#items');
        disableBodyScroll(this.targetElement);
    };
    Single.prototype.componentWillUnmount = function () {
        clearAllBodyScrollLocks();
    };
    Single.prototype.renderItem = function (bet, couponAmount, index, bets, accountResourceName, languageId) {
        var disabled = isRateUnavailable(bet.get('rate'));
        var bettingState;
        if (bet.get('unavailable') === true) {
            disabled = true;
            bettingState = bet.get('bettingState');
        }
        var props = {
            couponAmount: couponAmount,
            accountResourceName: accountResourceName,
            languageId: languageId,
            couponStatus: bets.get(bet.get('betNum')),
            match: bet.get('match'),
            outcome: bet.get('outcome'),
            rate: bet.get('rate'),
            deleteBetSlip: this.deleteBetSlip,
            prompt: this.props.prompt,
            betSlipsPromptClose: this.props.betSlipsPromptClose,
            disabled: disabled,
            bettingState: bettingState,
            currency: resourceNames[this.props.user.accountResourceId]
        };
        var itemCls = "item ".concat(cssClassMap[bet.get('rate').get('sportId')]);
        if (isRateUnavailable(bet.get('rate'))) {
            itemCls += ' disable';
        }
        if (bettingState) {
            itemCls += ' disable';
        }
        return (_jsx("div", __assign({ className: itemCls }, { children: _jsx("div", __assign({ className: 'item-inner' }, { children: _jsx(RenderBetItem, __assign({}, props)) })) }), index));
    };
    Single.prototype.render = function () {
        var _this = this;
        var _a = this.props, betSlips = _a.betSlips, couponAmount = _a.couponAmount, errorCode = _a.errorCode, bets = _a.bets, user = _a.user, intl = _a.intl, languageId = _a.languageId, freebet = _a.freebet, status = _a.status, client = _a.client;
        var freebetToggled = this.props.freebetToggled;
        var isBigStake = status === BetStatus.STAKE_REQUEST;
        if (betSlips.size > 1) {
            freebetToggled = false;
        }
        var currency = resourceNames[this.props.user.accountResourceId];
        var amount = getResourceAmount(this.props.user.accountResourceId, client.country);
        var couponAmountValue = freebetToggled ? freebet.amount : couponAmount;
        var renderBetSlip = [];
        var accountResourceId = user.accountResourceId;
        var accountResourceName = resourceNames[accountResourceId];
        betSlips.map(function (bet, i) {
            renderBetSlip.push(_this.renderItem(bet, couponAmount, i, bets, accountResourceName, languageId));
        });
        if (couponAmountValue !== '') {
            localStorage.setItem('couponAmountValue', couponAmountValue);
        }
        var getLocalStorage = Number(localStorage.getItem('couponAmountValue'));
        var savedCouponAmountValue = getLocalStorage > 0 ? getLocalStorage : '';
        var possibleWin = Math.ceil((this.props.odd * (couponAmountValue || savedCouponAmountValue)) * 1000) / 1000;
        return (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'items', id: 'items' }, { children: renderBetSlip })), _jsx("div", __assign({ className: 'data' }, { children: betSlips.size > 1 &&
                        _jsxs("div", { children: [_jsx(FormattedMessage, __assign({}, messages.total_bet_amount)), "\u00A0", _jsx("strong", __assign({ className: 'rate', id: 'express_factor' }, { children: betSlips.size * (couponAmount || savedCouponAmountValue) }))] }) })), _jsxs("div", __assign({ className: 'add' }, { children: [_jsxs("span", __assign({ className: 'stake-label' }, { children: [_jsx(FormattedMessage, __assign({}, messages.bets_potential_return)), _jsxs("span", { children: [_jsx("span", __assign({ className: 'possible-win-amount' }, { children: possibleWin ? possibleWin.toFixed(2) : possibleWin })), " ", currency] })] })), _jsxs("div", __assign({ className: 'control' }, { children: [_jsxs("span", { children: [betSlips.size > 1 &&
                                            _jsxs("span", { children: [" ", betSlips.size, " X "] }), _jsx("button", { className: 'subtract-btn', onClick: function () { return _this.subtractBtnHandler(savedCouponAmountValue, amount); } }), _jsx(_Input, { changeAmount: this.changeAmount, freebetToggled: freebetToggled, couponAmount: savedCouponAmountValue, placeholder: intl.formatMessage(messages.coupon_stake_amount), error: errorCode }), _jsx("button", { className: 'add-btn', onClick: function () { return _this.addBtnHandler(savedCouponAmountValue, amount); } })] }), !isBigStake && this.props.showError] }))] })), _jsx(StakeVariants, { freebetToggled: freebetToggled })] }));
    };
    return Single;
}(React.Component));
Single.propTypes = {
    bets: PropTypes.object.isRequired,
    betSlips: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    couponAmount: PropTypes.any.isRequired,
    prompt: PropTypes.bool.isRequired,
    errorCode: PropTypes.number.isRequired,
    betSlipsPromptClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    showError: PropTypes.any.isRequired,
    freebetToggled: PropTypes.bool.isRequired,
    freebet: PropTypes.object.isRequired,
    disableFreebet: PropTypes.func.isRequired,
    balance: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
};
var mapStateToProps = function (state, props) {
    var odd = 0;
    if (state.coupon.getIn(['betTypes', 0]) && state.coupon.getIn(['betTypes', 0]).odd) {
        odd = state.coupon.getIn(['betTypes', 0]).odd;
    }
    var balance = state.balance.value;
    return {
        user: state.auth.user,
        odd: odd,
        balance: balance,
        bets: state.coupon.getIn(['couponStatus', 'bets']),
        languageId: state.application.get('languageId'),
        client: state.application.get('client'),
    };
};
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeBetAmountAction: changeBetAmountAction
}, dispatch); };
Single = connect(mapStateToProps, mapDispatchToProps)(Single);
export default injectIntl(Single);



// WEBPACK FOOTER //
// ./src/components/coupon/betTypesComponents/Single.jsx